import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SkeletonModule } from "primeng/skeleton";

/**
 * Componente skeleton per il template process-setup
 *
 * Mostra uno skeleton che replica la struttura del template:
 * - Action sidenav con pulsante
 * - Container principale con tabella e paginazione
 */
@Component({
  selector: "ape-process-setup-skeleton",
  standalone: true,
  host: { class: "w-full" },
  imports: [CommonModule, SkeletonModule],
  templateUrl: "./ape-process-setup-skeleton.component.html"
})
export class ApeProcessSetupSkeletonComponent {
  /**
   * TrackBy function per ottimizzare il rendering delle liste
   */
  trackByIndex(index: number): number {
    return index;
  }
}
